<template>
  <sword-tooltip placement="top">
    <span ref="slot" class="cursor-pointer hover:bg-gray-200 hover:text-primary" @click="handleClipboard">
      <slot></slot>
    </span>
    <template #tooltip>
      <span>{{ $t('COPY.CLIPBOARD') }}</span>
    </template>
  </sword-tooltip>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useClipboard } from '@vueuse/core'

const props = defineProps<{
  textToCopy?: string;
}>()

const emit = defineEmits<{
  (e: 'on-copy', text: string): void;
}>()

const { copy } = useClipboard({ legacy: true })

const slot = ref<HTMLElement | null>(null)
const text = computed(() => slot.value?.textContent?.trim())

const handleClipboard = async () => {
  const content = props.textToCopy ?? text.value

  if (!content) return

  await copy(content)
  emit('on-copy', content)
}
</script>
